import axios from 'axios';
import authService from './AuthService';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/booklib/api` || 'http://localhost:8081/booklib/api',
});

// Request interceptor to add JWT token
api.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;